'use strict';

var errorMessage = $('#errormessage').val();
var toastMessageHelper = require('../../utils/toastMessageHelper');
var validateUtils = require('../../utils/dataAndSlots');

// Debounce timer to avoid too many API calls
var pincodeTimer = null;

$('body').on('click', '#vintagecarformpage-formdata .form-firstname-dropdown .custom-option-value', function () {
    var $this = $(this);
    var value = $this.data('title');
    var text = $this.text();
    $('#catalogueTitle').val(value);
    $this.closest('.custom-drop-down-section').find('.selected-value').text(text);
});

$('body').on('click', '#vintagepageShowbtn', function (e) {
    e.preventDefault();

    var datepickerInput = $('#ckc-astral-appointment-date').val();
    var slotInput = $('.astral-selected-value').text().trim().toLowerCase();
    $('#SelectedDate').val(datepickerInput);
    $('#SelectedTimer').val(slotInput);
    var isValid = true;

    if (datepickerInput === '') {
        $('.select-date-picker').removeClass('d-none');
        isValid = false;
    }

    if (slotInput === 'select your slot') {
        $('.slot-timepicker').removeClass('d-none');
        $('.noslots-available').addClass('d-none');
        isValid = false;
    }

    var $datePickerWrapper = $('.date-picker-input');
    var $slotdiv = $('.slot-dropdown-section');
    var $dateError = $('.select-date-picker');
    var $slotError = $('.slot-timepicker');
    if (!$slotError.hasClass('d-none')) {
        $slotdiv.addClass('is-invalid');
    } else {
        $slotdiv.removeClass('is-invalid');
    }

    if (!$dateError.hasClass('d-none')) {
        $datePickerWrapper.addClass('is-invalid');
    } else {
        $datePickerWrapper.removeClass('is-invalid');
    }

    if (!isValid) {
        return;
    }
    $.spinner().start();
    var url = $('#vintagepageShowbtn').data('url');
    $.ajax({
        url: url,
        type: 'GET',
        data: {
            appointmentDate: datepickerInput,
            appointmentSlot: slotInput
        },
        success: function (response) {
            $('#VintageCarpage').addClass('d-none');
            $('#vintagecar-formdata').removeClass('d-none');
            $('#vintagecar-formdata').html(response);
            $.spinner().stop();
            $('html, body').animate({
                scrollTop: $('#vintagecar-formdata').offset().top
            }, 500);
            $('#vintagecar-formdata').scrollTop(0);
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$(document).on('click', '#vintagecartimeslotplaced li', function () {
    $('.slot-timepicker').addClass('d-none');
    $('#slot-dropdown-section').removeClass('is-invalid');
});

$(document).on('change', '#ckc-astral-appointment-date', function () {
    $('.select-date-picker').addClass('d-none');
    $('.date-picker-input').removeClass('is-invalid');
});

$('body').on('change input blur', '#vintagecarformpage-formdata input', function () {
    validateUtils.validateField($(this));
    if ($(this).hasClass('firstname-input')) {
        var $customDropdown = $('.firstname-input-field').find('.custom-drop-down');
        if ($(this).hasClass('is-invalid')) {
            $customDropdown.addClass('error-valid');
        } else {
            $customDropdown.removeClass('error-valid');
        }
    }
    if ($(this).hasClass('phone-input')) {
        var $phoneDropdown = $('.phone-input-field').find('.custom-drop-down');
        if ($(this).hasClass('is-invalid')) {
            $phoneDropdown.addClass('error-valid');
        } else {
            $phoneDropdown.removeClass('error-valid');
        }
    }
});

$('body').on('input blur', '#vintagecarformpage-formdata input', function () {
    var $field = $(this);
    var value = $field.val();
    value = value.replace(/^\s+/, '');
    value = value.replace(/\s{2,}/g, ' ');
    if ($field.attr('type') === 'email') {
        value = value.replace(/\s+/g, '');
    }
    $field.val(value);
});

/**
 * Handle click event on vintageSubmitDatabtn to fetch input values
 */
$('body').on('click', '#vintageSubmitDatabtn', function (e) {
    e.preventDefault();

    var isFormValid = true;
    $('#vintagecarformpage-formdata').find('input').each(function () {
        if (!validateUtils.validateField($(this))) {
            isFormValid = false;
        }
    });

    if (!isFormValid) {
        var $formTop = $('#vintagecarformpage-formdata').offset();
        if ($formTop) {
            $('html, body').animate({ scrollTop: $formTop.top - 20 }, 400);
        }
        return;
    }

    var submitUrl = $('#vintagecarformpage-formdata').data('submiturl');

    var formData = {
        salutation: $('#catalogueTitle').val(),
        firstName: $('#firstName').val(),
        lastName: $('#lastName').val(),
        email: $('#email').val(),
        phone: $('#phone').val(),
        countryCode: $('#requestCatalogueModal .country-code .selected-value').text().trim(),
        pincode: $('#pincode').val(),
        city: $('#city').val(),
        address1: $('#Address1').val(),
        address2: $('#Address2').val(),
        optionattribute: $('#optionattribute').val(),
        State: $('#state').val(),
        slotInput: $('#SelectedTimer').val(),
        datepickerInput: $('#SelectedDate').val(),
        termsAndConditionsAccepted: $('#termsAccepted').is(':checked')
    };
    $.spinner().start();
    $.ajax({
        url: submitUrl,
        type: 'POST',
        data: formData,
        success: function (response) {
            if (response) {
                $.ajax({
                    url: response.redirectUrl,
                    type: 'GET',
                    data: {
                        appointmentID: response.appointmentID
                    },
                    success: function (dataresponse) {
                        $('#vintagecar-formdata').addClass('d-none');
                        $('#vintagecarfocuspage').removeClass('d-none').html(dataresponse);
                        $.spinner().stop();
                        $('html, body').animate({
                            scrollTop: $('#vintagecarfocuspage').offset().top
                        }, 500);
                        $('#vintagecarfocuspage').scrollTop(0);
                    },
                    error: function () {
                        $.spinner().stop();
                        toastMessageHelper.showNotification(errorMessage);
                    }
                });
            }
        },
        error: function () {
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

$('body').on('click', '#vintagecarformpage-formdata .country-code .custom-option-value', function () {
    var $this = $(this);
    var countryCode = $this.data('id');
    var phoneLength = $this.data('phonelength');
    var $phoneInput = $('#vintagecarformpage-formdata .phone-input');
    $phoneInput.attr('data-countrycode', countryCode);
    $this.closest('.custom-drop-down-section').find('.selected-value').text(countryCode);
    $this.siblings().removeClass('selected');
    $this.addClass('selected');
    if (phoneLength) {
        $phoneInput.attr('maxlength', phoneLength);
    }
    $phoneInput.val('');
    $phoneInput.removeClass('is-invalid');
    $phoneInput.siblings('.invalid-feedback').text('').hide();
});

$('body').on('click', '#VintageCarpage .time-slot-session .time-slot-value', function () {
    var $this = $(this);
    var $selected = $this.closest('.time-slot-select').find('.custom-drop-down-section .selected-value');
    if ($selected.length) {
        $selected.addClass('timeslot-selected-value');
    }
});

$('body').on('input', '#pincode', function () {
    var pincode = $(this).val().trim();
    var country = $('#vintagecarformpage-formdata').data('country') || 'India';

    if (pincode.length < 4) {
        $('#city, #state').val('');
        return;
    }

    clearTimeout(pincodeTimer);
    pincodeTimer = setTimeout(function () {
        validateUtils.fetchPlace('', pincode, country);
    }, 400);
});

$('body').on('click', '#vintage-proceed-btn', function () {
    var appointmentID = $('#appointmentID').val();
    var $form = $('.vintage-detailsoption');
    var dataUrl = $(this).data('url');
    var whatsappOption = $form.find('#whatsappoption').is(':checked');
    var textmessage = $form.find('#textoption').is(':checked');
    var emailOption = $form.find('label[for="emailoption"]').hasClass('checked');
    $.spinner().start();
    $.ajax({
        url: dataUrl,
        type: 'get',
        data: {
            appointmentID: appointmentID,
            whatsappOption: whatsappOption,
            textmessage: textmessage,
            emailOption: emailOption
        },
        success: function (response) {
            if (response) {
                $('#vintagecarfocuspage').addClass('d-none');
                $('#vintageComfirmationPage').removeClass('d-none');
                $('.pd-hero-banner, .service-image-banner, .astralcomponent-container, .testimonial-section').addClass('d-none');
                $('.storepage .service-image-banner:last').removeClass('d-none');
                $('.divider-image.text-center').removeClass('d-none');
                $('#vintageComfirmationPage').html(response);
                $.spinner().stop();
                $('html, body').animate({
                    scrollTop: $('#vintageComfirmationPage').offset().top
                }, 500);
                $('#vintageComfirmationPage').scrollTop(0);
            }
        },
        error: function () {
            $.spinner().stop();
            toastMessageHelper.showNotification(errorMessage);
        }
    });
});

/**
 * Fetches and updates available vintage car appointment time slots
 * based on the selected date and customer details.
 *
 * Collects selected appointment date, customer contact information,
 * and previously selected time slot, then sends an AJAX POST request
 * to retrieve updated time slot HTML content. On success, it replaces
 * the existing vintage car time slot container content.
 *
 * @function updateVintageCarSlots
 * @returns {void}
 */
function updateVintageCarSlots() {
    var selectedDate = $('#ckc-astral-appointment-date').val().trim();
    var selectedslot = $('.astral-selected-value').attr('data-slot');
    var url = $('#vintagecartimeslot').data('url');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var tryatshowroomData = {
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot || ''
    };

    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#vintagecartimeslotplaced').html('');
            if (data.success === false) {
                return;
            }
            $('#vintagecartimeslotplaced').html(data);
        }
    });
}

$('body').on('change', '#ckc-astral-appointment-date', function () {
    var $tasSelectedValue = $('.astral-selected-value');
    if ($tasSelectedValue.length) {
        var altText = $tasSelectedValue.attr('data-alttext') || $tasSelectedValue.data('alttext');
        $tasSelectedValue.text(altText || '');
        $tasSelectedValue.removeClass('timeslot-selected-value');
        $tasSelectedValue.attr('data-slot', '');
    }

    updateVintageCarSlots();
});

$('body').on('click', '#backto-vintagepage', function (e) {
    e.preventDefault();
    $('#vintagecar-formdata').addClass('d-none');
    $('#VintageCarpage').removeClass('d-none');
    $('html, body').animate({
        scrollTop: $('#VintageCarpage').offset().top
    }, 500);
});

$('body').on('click', '#vintagecartimeslot', function () {
    var $this = $(this);
    if ($this.data('requesting') === true) {
        return;
    }
    var selectedDate = $('#ckc-astral-appointment-date').val().trim();
    if (!selectedDate) {
        return;
    }
    var selectedslot = $('.astral-selected-value').attr('data-slot');
    var url = $(this).data('url');
    var customerPhone = $('.customerPhone').val();
    var customerEmail = $('.customerEmail').val();
    var tryatshowroomData = {
        customerPhone: customerPhone,
        customerEmail: customerEmail,
        selectedDate: selectedDate,
        tasSelectedValue: selectedslot
    };
    $this.data('requesting', true);
    $.spinner().start();
    $.ajax({
        url: url,
        method: 'POST',
        data: tryatshowroomData,
        success: function (data) {
            $('#vintagecartimeslotplaced').html('');
            if (data.success === false) {
                $('.noslots-available').removeClass('d-none');
                $('.pickup-slots').addClass('d-none');
                $.spinner().stop();
                $this.data('requesting', false);
                return;
            }
            $('#vintagecartimeslotplaced').html(data);
            $('.pickup-slot-scroll').scrollTop(0);
            $.spinner().stop();
            $this.data('requesting', false);
        },
        error: function () {
            $.spinner().stop();
            $this.data('requesting', false);
        }
    });
});

$('body').on('click', '#vintagecartimeslot .time-slot-value', function () {
    if ($(this).hasClass('strick-out')) return;
    var selectedSlot = $(this).data('id');
    $('#vintagecartimeslotplaced').val(selectedSlot);
    $('.astral-selected-value').attr('data-slot', selectedSlot);
});
